import BLMCheckText from './main.vue'
import BLMCheckTextInputFirefox from './fireFox.vue'

const isFirefox = navigator.userAgent.includes('Firefox')
const BLMCheckTextInput = isFirefox ? BLMCheckTextInputFirefox : BLMCheckText

export default BLMCheckTextInput
